const TOKEN_KEY = 'token'
const PERFIL_KEY = 'perfil'
const REFRESH_TOKEN_KEY = 'refresh_token'

/**
 * Manage the how Access Tokens are being stored and retreived from storage.
 *
 * Current implementation stores to localStorage. Local Storage should always be
 * accessed through this instace.
 **/
const TokenService = {
    getToken() {
        const token = localStorage.getItem(TOKEN_KEY);
        return token;
    },

    saveToken(accessToken) {
        localStorage.setItem(TOKEN_KEY, accessToken)
    },

    removeToken() {
        localStorage.removeItem(TOKEN_KEY)
    },

    getPerfil() {
        return localStorage.getItem(PERFIL_KEY)
    },

    savePerfil(accessPerfil) {
        localStorage.setItem(PERFIL_KEY, accessPerfil)
    },

    removePerfil() {
        localStorage.removeItem(PERFIL_KEY)
    },

    getRefreshToken() {
        return localStorage.getItem(REFRESH_TOKEN_KEY)
    },

    saveRefreshToken(refreshToken) {
        localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken)
    },

    removeRefreshToken() {
        localStorage.removeItem(REFRESH_TOKEN_KEY)
    }

}

export { TokenService }